export const api2BaseURL = import.meta.env.VITE_API2_BASE_URL;
export const appBaseURL =
  import.meta.env.VITE_APP_BASE_URL ?? "https://app.rulebase.co";

if (!api2BaseURL) {
  throw new Error("VITE_API2_BASE_URL is not set");
}
